<div>
  <footer class="modal-footer">
    <ng-content></ng-content>
  </footer>
</div>
